<div style="font-family: Arial, sans-serif; color: #333; padding-top: 200px; padding-bottom: 400px;">
    <div style="max-width: 600px; margin: auto; padding: 20px; border: 1px solid #e0e0e0; border-radius: 10px;">
        <h1 style="color: #2a9d8f;">Verifikacija e-pošte</h1>
        <p>Verifikacijski email je bil poslan na vaš e-mail račun, prosimo potrdite ga.</p>
        
        <div style="background-color: #f9f9f9; padding: 15px; border-radius: 10px; margin-top: 20px;">
            <h2 style="color: #e76f51;">Pomembno obvestilo:</h2>
            <p>Verifikacija se izteče v petih minutah.</p>
        </div>
        
        <div style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #e0e0e0;">
            <p>Hvala za vašo pozornost.</p>
            <p>Lep pozdrav,</p>
            <p><em>Vaša ekipa Hotedrsica.si</em></p>
        </div>
    </div>
</div>
